import { render, staticRenderFns } from "./VMV.vue?vue&type=template&id=b96b6f7e&scoped=true"
import script from "./VMV.vue?vue&type=script&lang=js"
export * from "./VMV.vue?vue&type=script&lang=js"
import style0 from "./VMV.vue?vue&type=style&index=0&id=b96b6f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96b6f7e",
  null
  
)

export default component.exports